import React from "react";
import { useTranslation } from "react-i18next";
import {
  formatStorePriceAmount,
} from "../../../utils/storeUtils";
import RiyalSymbol from "./RiyalSymbol";
import "./StorePriceDisplay.css";

function isArabicLang(lang) {
  return String(lang || "en").toLowerCase().startsWith("ar");
}

export function StorePriceDisplay({ amount, fractionDigits = 2, className = "" }) {
  const { t, i18n } = useTranslation("global");
  const lang = i18n.language;
  const n = Number(amount);
  if (!Number.isFinite(n)) {
    return (
      <span className={className}>
        {t("store.priceMissing", { defaultValue: "—" })}
      </span>
    );
  }
  const formatted = formatStorePriceAmount(n, lang, fractionDigits);
  if (isArabicLang(lang)) {
    return (
      <span
        className={`store-price-display ${className}`.trim()}
        dir="ltr"
        lang="ar"
      >
        <RiyalSymbol className="store-price-display__riyal" />
        <span className="store-price-display__amount">{formatted}</span>
      </span>
    );
  }
  return (
    <span className={className} dir="ltr">
      {fractionDigits === 2
        ? t("store.priceWithCurrency", {
            amount: formatted,
            defaultValue: "{{amount}} SAR",
          })
        : `${formatted} SAR`}
    </span>
  );
}

export function StorePriceEachDisplay({ amount, className = "" }) {
  const { t, i18n } = useTranslation("global");
  const lang = i18n.language;
  const n = Number(amount);
  if (!Number.isFinite(n)) {
    return (
      <span className={className}>
        {t("store.priceMissing", { defaultValue: "—" })}
      </span>
    );
  }
  const formatted = formatStorePriceAmount(n, lang, 2);
  if (isArabicLang(lang)) {
    return (
      <span
        className={`store-price-display store-price-each ${className}`.trim()}
        dir="ltr"
        lang="ar"
      >
        <RiyalSymbol className="store-price-display__riyal" />
        <span className="store-price-display__amount">{formatted}</span>
        <span className="store-price-each__suffix">
          {t("store.priceEachSuffix", { defaultValue: "each" })}
        </span>
      </span>
    );
  }
  return (
    <span className={className} dir="ltr">
      {t("store.priceEach", {
        amount: formatted,
        defaultValue: "{{amount}} SAR each",
      })}
    </span>
  );
}

export function StoreMoneyDisplay({
  amount,
  currencyCode = "SAR",
  className = "",
}) {
  const { t, i18n } = useTranslation("global");
  const lang = i18n.language;
  const n = Number(amount);
  if (!Number.isFinite(n)) {
    return (
      <span className={className}>
        {t("store.priceMissing", { defaultValue: "—" })}
      </span>
    );
  }
  const code = (currencyCode || "SAR").toUpperCase();
  if (code === "SAR") {
    return <StorePriceDisplay amount={n} className={className} />;
  }
  const formatted = formatStorePriceAmount(n, lang, 2);
  const currencyLabel = t(`store.currency.${code}`, { defaultValue: code });
  return (
    <span className={className} dir="ltr">
      {t("store.priceAmountAndCode", {
        amount: formatted,
        currency: currencyLabel,
        defaultValue: "{{amount}} {{currency}}",
      })}
    </span>
  );
}
